import PropTypes from 'prop-types';
// @mui
import { Typography, Stack, CardMedia } from '@mui/material';
//
import img from './../../assets/icons/empty_content.svg'
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

EmptyContent.propTypes = {
  sx: PropTypes.object,
  img: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default function EmptyContent({image=img, title, description, sx, ...other }) {
  const {t} = useTranslation()
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: 1,
        textAlign: 'center',
        // p: (theme) => theme.spacing(8, 2),
        p:'64px 16px 16px',
        ...sx,
      }}
      {...other}
    >
      <CardMedia
      component={'img'}
        disabledEffect
        alt="empty content"
        loading='lazy'
        src={image}
        sx={{ height: 300, mb: 3, objectFit:{md:'contain', xs:'fill'} }}
      />

      <Typography variant="h5" gutterBottom>
        <bdi> {title || t('empty.description')}</bdi>
      </Typography>

      {description && (
        <Typography variant="body2" >
          {description}
        </Typography>
      )}
    </Stack>
  );
}
